<div class="actions-wrap" *ngIf="(tag || allowWithoutTag) && visibleActionCount > 0">
  <ng-container *ngIf="shouldCollapseToSingleAction; else actionsMenu">
    <ng-container *ngIf="!hideTrendAction && tag && !isAdmin; else viewOnly">
      <ion-button
        [id]="uniqueIdentifier"
        fill="clear"
        size="small"
        [attr.aria-label]="trendActionLabel"
        [attr.title]="trendActionLabel"
        (click)="onToggleTrend($event)">
        <ion-icon slot="icon-only" [name]="inBucket ? 'remove-circle-outline' : 'add-outline'"></ion-icon>
      </ion-button>
    </ng-container>
    <ng-template #viewOnly>
      <ion-button
        [id]="uniqueIdentifier"
        fill="clear"
        size="small"
        aria-label="View insight"
        title="View insight"
        (click)="onViewInsight($event)">
        <ion-icon slot="icon-only" name="eye-outline"></ion-icon>
      </ion-button>
    </ng-template>
  </ng-container>

  <ng-template #actionsMenu>
    <ion-button [id]="uniqueIdentifier" fill="clear" size="small" aria-label="More actions" (click)="openActions($event)">
      <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
    </ion-button>

    <ng-container *ngIf="usePopoverActions; else actionsActionSheet">
      <ion-popover
        #actionsPopover
        [isOpen]="isModalOpen"
        [event]="actionsEvent"
        [dismissOnSelect]="true"
        (didDismiss)="closeActions(undefined, true)"
      >
        <ng-template>
          <ion-list lines="none">
            <ion-item button detail="false" (click)="onViewInsight($event)" *ngIf="isAdmin">
              <ion-icon slot="start" name="eye-outline"></ion-icon>
              <ion-label>View tag insight</ion-label>
            </ion-item>
            <ion-item
              button
              detail="false"
              *ngFor="let a of extraActions; trackBy: trackByExtraAction"
              (click)="onExtraAction(a.id, $event)"
              [disabled]="!!a.disabled"
            >
              <ion-icon slot="start" [name]="a.icon || 'options-outline'"></ion-icon>
              <ion-label>{{ a.text }}</ion-label>
              <ion-icon slot="end" name="checkmark" *ngIf="a.checked"></ion-icon>
            </ion-item>
            <ion-item button detail="false" (click)="onToggleTrend($event)" *ngIf="!hideTrendAction && tag">
              <ion-icon slot="start" [name]="inBucket ? 'remove-circle-outline' : 'add-outline'"></ion-icon>
              <ion-label>{{ trendActionLabel }}</ion-label>
            </ion-item>
            <ion-item button detail="false" (click)="closeActions($event)">
              <ion-icon slot="start" name="close"></ion-icon>
              <ion-label>Cancel</ion-label>
            </ion-item>
          </ion-list>
        </ng-template>
      </ion-popover>
    </ng-container>
    <ng-template #actionsActionSheet>
      <ion-action-sheet
        [isOpen]="isModalOpen"
        [header]="'Insight actions'"
        [buttons]="actionsButtons"
        (didDismiss)="closeActions(undefined, true)"
      ></ion-action-sheet>
    </ng-template>
  </ng-template>
</div>
